import React, { useEffect } from 'react';
import { getChatContainer } from 'utils/getChatContainer';
import { richContentSelect, welcomeFormSelect } from '../styles/reactSelect';
import { floatingUi } from '../styles/floatingUi';

export default function useCopyStyles({ disableSecuredStyles }) {
  const copyStyles = () => {
    const shadowRoot = getChatContainer(disableSecuredStyles);

    const richSelect = 'rich-content-select';
    const formSelect = 'welcome-form-select';

    if (!shadowRoot.querySelector(`style[data-style="${richSelect}"]`)) {
      const rich = document.createElement('style');
      rich.setAttribute('data-style', richSelect);
      rich.textContent = richContentSelect;
      shadowRoot.appendChild(rich);
    }

    if (!shadowRoot.querySelector(`style[data-style="${formSelect}"]`)) {
      const welcome = document.createElement('style');
      welcome.setAttribute('data-style', formSelect);
      welcome.textContent = welcomeFormSelect;
      shadowRoot.appendChild(welcome);
    }

    if (!document.querySelector(`style[data-style="floating-ui"]`)) {
      const floatingUiStyle = document.createElement('style');
      floatingUiStyle.setAttribute('data-style', 'floating-ui');
      floatingUiStyle.textContent = floatingUi;
      document.body.appendChild(floatingUiStyle);
    }
  };

  useEffect(() => {
    if (!disableSecuredStyles) {
      copyStyles();
    }
  }, [disableSecuredStyles]);
}
